import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.ui`;
export const INIT = `${SCOPE}/INIT`;
export const ON_EXPAND_EVENT = `${SCOPE}/ON_EXPAND_EVENT`;
export const HIGHLIGHT_MOMENT_BY_EVENT = `${SCOPE}/HIGHLIGHT_MOMENT_BY_EVENT`;
export const REMOVE_HIGHLIGHT_BY_EVENT = `${SCOPE}/REMOVE_HIGHLIGHT_BY_EVENT`;
export const APPLY_TIMELINE_UI = `${SCOPE}/APPLY_TIMELINE_UI`;
